import { Tooltip } from "./Tooltip";
import { InfoIcon } from "../../../atoms/icons/info-i";
import React, { useState, useEffect } from "react";
import ClickAwayListener from "@mui/material/ClickAwayListener";

export const TooltipCombo = ({ tip, isViewDetails = false }) => {
  const [isOpenI, setIsOpenI] = useState(false);
  const [isMobile, setIsMobile] = useState(
    window.matchMedia("(max-width: 768px)").matches
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.matchMedia("(max-width: 768px)").matches);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleTooltipToggle = () => setIsOpenI(!isOpenI);

  if (!tip) {
    return null;
  }

  return (
    <>
      {!isMobile && (
        <Tooltip
          title={<div className="accordion-tooltip">{tip}</div>}
          enterTouchDelay={0}
          leaveTouchDelay={0}
          PopperProps={{
            popperOptions: {
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, -14],
                  },
                },
              ],
            },
          }}
        >
          <div className={`${isViewDetails ? "i-icon-shifted" : "i-icon"}`}>
            <InfoIcon
              className="info-icon"
              fill="lightgrey"
              width="20px"
              height="20px"
            />
          </div>
        </Tooltip>
      )}

      {isMobile && (
        <ClickAwayListener onClickAway={() => setIsOpenI(false)}>
          <Tooltip
            title={<div className="accordion-tooltip">{tip}</div>}
            onClose={() => setIsOpenI(false)}
            open={isOpenI}
            PopperProps={{
              popperOptions: {
                modifiers: [
                  {
                    name: "offset",
                    options: {
                      offset: [0, -22],
                    },
                  },
                ],
              },
            }}
          >
            <div
              className={`${isViewDetails ? "" : "i-icon"}`}
              onClick={handleTooltipToggle}
            >
              <InfoIcon
                className="info-icon"
                fill="lightgrey"
                width="20px"
                height="20px"
              />
            </div>
          </Tooltip>
        </ClickAwayListener>
      )}
    </>
  );
};
